
import { Component, AfterViewInit, EventEmitter, OnInit, Output, Input } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { NgxSpinnerService } from "ngx-spinner";
import { MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';
import { AlertboxComponent } from '../alertbox/alertbox.component'
import { HttpErrorResponse } from '@angular/common/http';
import { MatPaginatedTabHeader } from '@angular/material/tabs/paginated-tab-header';
import { matDatepickerAnimations } from '@angular/material/datepicker';
import { DatePipe } from '@angular/common';
import { StudentRegistrationTabComponent } from '../student-registration-tab/student-registration-tab.component';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { finalize } from 'rxjs/operators';
import { Router } from '@angular/router';
@Component({
  selector: 'app-personal-details',
  templateUrl: './personal-details.component.html',
  styleUrls: ['./personal-details.component.scss'],
})
export class PersonalDetailsComponent implements OnInit, AfterViewInit {
  // @Input() tabName: string = '';
  @Output() next = new EventEmitter<void>();
  @Output() first = new EventEmitter<void>();
  submitpayload: any;
  dialogRef: MatDialogRef<any>;
  marritalList: any;
  filteredmarritalstatusList: any;
  bloodgroupList: any;
  filteredBloodGroupList: any;
  genderList: any;
  filteredGenderList: { CdActive: String, CdCode: String, CdDesc: String, CdProc: String, CdSeq: Number, CdType: String, }[];
  maxNumberOfTabs = 1;
  disabled = false;
  // tab;
  FormRequired = "*";
  filteredMotherToungList: any;
  mothertoungList: any;
  session = sessionStorage.getItem('session');
  Scrutiny: any;
  Course: any;
  College: any;
  tabs: string;
  displayName: any;
  AdmInfoCodeList: any;
  filteredListAdmInfoCode: any;
  RgNoPrFx: any;
  SnNo: any;
  studentFullName : any;
  hasDocumentErrors: boolean = false;
  documentErrorFields: string[] = []; 
  editableFields: Set<string> = new Set();
  StuFullNameEng : any;
  IsRegStudent :boolean = false;
  constructor(
    //  public tab: StudentRegistrationTabComponent,
    private fb: FormBuilder,
    private router: Router,
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private spinner: NgxSpinnerService,
    public datepipe: DatePipe,
  ) { }
  personalDetailsForm: FormGroup;
  submitButton = true;
  updateButton = false
  minDate: Date;
  currentdate: any;
  FirstName: string
  MiddleName: string
  LastName: string
  Number
  Email: string
  personalDetailsFormArray;
  selectedIndex: number = 0;
  years: number[] = this.generateYears(1975, new Date().getFullYear());
  studentId = sessionStorage.getItem('StudentRGID');
  StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
  personalShow = false;
  calledApi = 0; // Total number of APIs called
  finishedApi = 0; // Total number of APIs completed (success or failure)
  ngOnInit(): void {
    this.submitButton = true;
    this.updateButton = false
    this.personalShow = false;
    // this.StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
    this.spinner.show();
    this.fetchMarritalStatus();
    this.fetchBloodGroup();
    this.fetchGender();
    this.fetchMotherTounge();
    this.fetchAdmInfo();   //to be added again when asked later for other universities too
    let a = sessionStorage.getItem('userId')
    this.disabled = false;
    this.currentdate = new Date();
    this.minDate = new Date(1900, 0, 1);
    // this.loadsettingspage();
    this.getUserData(sessionStorage.getItem('StudentRGID'));
    this.getSecretData()
    
    this.getApplyData();
    this.personalDetailsForm = this.fb.group({
      StuRgNo: new FormControl(this.studentId),
      StuId: new FormControl(""),
    });
    this.prepopulation();
    this.prepopulationContact();
   }

   getSecretData() {
    this.calledApi++;
    let payload = {};
    this.umsService.getSecretData().subscribe((res) => {
      if(res.status){
        this.SnNo = res.projectPharam['SnNo'];
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        };
      }
      else{
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        };
      }
    },(ERROR:HttpErrorResponse) => {
      this.finishedApi++;
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      };
    });
  }

   getFeeStatus(StuId){
    console.log('i will check fees status for student id');
    
    const payload = {};
    payload['StuId'] = StuId;
    payload['SnNo'] = this.session;
    this.umsService.getFeeStatus(payload).subscribe(res => {
      console.log('res of fees status is',res);
      
      if(res.status){
        console.log('fees status response i get is',res.data);
        this.getScrutiny(StuId)
      }
      else{
        this.disabled = false;
      }
    },(ERROR:HttpErrorResponse) => {
      this.disabled = false;
    })
   }

  getUserData(id) {
    this.calledApi++;
    this.FirstName = sessionStorage.getItem('StuFirstName');
    //this is middle name not a father name
    this.MiddleName = sessionStorage.getItem('StuMidName');
    this.LastName = sessionStorage.getItem('StuLastName');
    this.Number = sessionStorage.getItem('StuMobNumber');
    this.Email = sessionStorage.getItem('StuEmailId');

    this.umsService.getUserData(id).subscribe((res) => {
      if (res.status) {
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        };
        this.FirstName = res.data[0][0]['StuFirstName']
        //this is middle name not a father name
        this.MiddleName = res.data[0][0]['StuMidName']
        this.LastName = res.data[0][0]['StuLastName']
        this.Number = parseInt(res.data[0][0]['StuMobNumber'])
        this.Email = res.data[0][0]['StuEmailId']
      }
      else {
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++;
      if (this.finishedApi === this.calledApi) { 
        this.spinner.hide();
      }
    });
  }
   updateEditableFields() {
  this.editableFields.clear();
  this.documentErrorFields.forEach(errorField => {
    switch(errorField) {
      case 'FirstName':
      case 'StuFirstNameEng':
        this.editableFields.add('StuFirstNameEng');
        break;
      case 'MiddleName':
      case 'StuMiddleName':
        this.editableFields.add('StuMiddleName');
        break;
      case 'LastName':
      case 'StuLastNameEng':
        this.editableFields.add('StuLastNameEng');
        break;
      case 'MotherName':
      case 'StuMothNameEng':
        this.editableFields.add('StuMothNameEng');
        break;
      case 'FatherName':
      case 'StuMidNameEng':
        this.editableFields.add('StuMidNameEng');
        break;
      case 'FullName':
      case 'StudentFullName':
        this.editableFields.add('StudentFullName');
        break;
      case 'BirthDate':
      case 'StuBirthDate':
        this.editableFields.add('StuBirthDate');
        break;
      default:
      
        if (this.personalDetailsForm.contains(errorField)) {
          this.editableFields.add(errorField);
        }
    }
  });

  console.log('Editable fields due to document errors:', Array.from(this.editableFields));
}

  isFieldEditable(fieldName: string): boolean {
  if (this.hasDocumentErrors) {
    return this.editableFields.has(fieldName);
  }
  return this.updateButton && !this.disabled;
}

  ngAfterViewInit(): void {
    // this.loadsettingspage();
    // this.prepopulation();
  }

  getScrutiny(StuId) {
      this.calledApi++;
      const payload = {};
      payload['StudentId'] = StuId;
      this.umsService.fetchScrutinyLock(payload).subscribe(res => {
        this.tabs = res.data[0].Tabs;
        if (res.data.length == 0 || res.data[0]['Status'] == 'DCERR') {
          this.finishedApi++;
          if (this.finishedApi === this.calledApi) {
            this.spinner.hide();
          }
          if (res.data[0].Tabs.includes('Personal Details')) {
            this.disabled = false;
          } else {
            this.disabled = true;
          }
        }
        else {
          this.finishedApi++;
          if (this.finishedApi === this.calledApi) {
            this.spinner.hide();
          }
          this.disabled = true;
        }
      }, (ERROR: HttpErrorResponse) => {
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      });
  }

  generateYears(startYear: number, endYear: number): number[] {
    const years = [];
    for (let year = startYear; year <= endYear; year++) {
      years.push(year);
    }
    return years;
  }

  onYearSelect(event: any) {
    const selectedYear = event.value;
  }

  prepopulation() {
    this.calledApi++;
    let payload = {};
    payload['StuRgNo'] = this.studentId;
    this.umsService.fetchPersonalDetails(payload).subscribe(async(res) => {
      if (res.status) {
        if (res.data.length > 0) {
          this.StudentPersonalId = res.data[0].StuId
          this.studentFullName = res.data[0].StudentFullName;
          this.StuFullNameEng = res.data[0].StuFullNameEng;
          this.IsRegStudent = res.data[0].IsRegStudent;
          sessionStorage.setItem("StudentPersonalId", res.data[0].StuId);
          this.submitButton = false;
          this.updateButton = true;
          this.prepopulatedatapage(res);
          this.prepopulationContact();
        } else {
          this.loadsettingspage();
        }
        console.log('i have data in personal details');
        
        await this.getFeeStatus(res.data[0].StuId)
        // this.getScrutiny(res.data[0].StuId);
      } else {
        this.loadsettingspage();
        // this.getScrutiny(0)
      }
    }, (ERROR: HttpErrorResponse) => {
      // this.spinner.hide()
      // this.getScrutiny(0)
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    })
  }

  prepopulatedatapage(e) {
    let payload = {};
    payload['FormPage'] = 'PersonalDetails';
    // this.personalDetailsForm.controls['StuId'].setValue(e.data[0]['StuId']); REMOVED THIS
    this.umsService.getStdSetting(payload).subscribe((ress) => {
      if(ress.status){
        if(this.studentFullName == null) {
          ress.data[26].FormRequired = false;
        }
        if(this.StuFullNameEng == null) {
          ress.data[7].FormRequired = false;
        }
        if(e.data[0].IsRegStudent) {
          ress.data[27].FormControlName = "StudentRegNo";
        }
         ress.data.forEach((element) => {
          if (element.FormVisible) {
            if (element.FormControlName == 'EmailID' && element.FormRequired == true) {
              this.personalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], [Validators.required, Validators.email, Validators.pattern('(?![0-9]+@)([A-Za-z0-9._%-]+)@([A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*)\.[A-Za-z]{2,3}')]));
            }
            else if (element.FormControlName == 'EmailID' && element.FormRequired == false) {
              this.personalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], [Validators.email, Validators.pattern('(?![0-9]+@)([A-Za-z0-9._%-]+)@([A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*)\.[A-Za-z]{2,3}')]));
            }
            if (element.FormRequired) {
  
              if (element.FormPattern == '') {
                this.personalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], Validators.required));
              }
              else {
                this.personalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], [Validators.required, Validators.pattern(element.FormPattern)]));
              }
            }
            else {
              if (element.FormPattern == '') {
                this.personalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
              } else {
  
                this.personalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], [Validators.pattern(element.FormPattern)]));
              }
            }
          } else {
            this.personalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
          }
        });
        this.submitButton = false;
        this.updateButton = true;
        this.personalDetailsForm.addControl('StuId', new FormControl(e.data[0]['StuId'])); // ADDED THIS
        this.mapdataaa(ress.data);
      }
      else{
        this.finishedApi++
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });

  }
  loadsettingspage() {
   
    let payload = {};
    payload['FormPage'] = 'PersonalDetails';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      if(res.status){
       
        res.data.forEach((element) => {
          if (element.FormVisible) {
            switch (element.FormControlName) {
              case "StuFirstNameEng":
                this.personalDetailsForm.addControl(element.FormControlName, new FormControl(this.FirstName));
                break;
                //this is middle name not a father name
              case "StuMiddleName":
                this.personalDetailsForm.addControl(element.FormControlName, new FormControl(this.MiddleName));
                break;
              case "StuLastNameEng":
                this.personalDetailsForm.addControl(element.FormControlName, new FormControl(this.LastName));
                break;
              case "StuNumber":
                this.personalDetailsForm.addControl(element.FormControlName, new FormControl(this.Number));
                break;
              case "EmailID":
                this.personalDetailsForm.addControl(element.FormControlName, new FormControl(this.Email));
                break;
            }
            if (element.FormControlName == 'EmailID' && element.FormRequired == true) {
              this.personalDetailsForm.addControl(element.FormControlName, new FormControl('', [Validators.required, Validators.email, Validators.pattern('(?![0-9]+@)([A-Za-z0-9._%-]+)@([A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*)\.[A-Za-z]{2,3}')]));
            }
            else if (element.FormControlName == 'EmailID' && element.FormRequired == false) {
              this.personalDetailsForm.addControl(element.FormControlName, new FormControl('', [Validators.email, Validators.pattern('(?![0-9]+@)([A-Za-z0-9._%-]+)@([A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*)\.[A-Za-z]{2,3}')]));
            }
            if (element.FormRequired) {
              if (element.FormPattern == '') {
                // this.personalDetailsForm.get('element').markAsTouched();
                this.personalDetailsForm.addControl(element.FormControlName, new FormControl('', Validators.required));
              }
              else {
                this.personalDetailsForm.addControl(element.FormControlName, new FormControl('', [Validators.required, Validators.pattern(element.FormPattern)]));
              }
            } else {
              if (element.FormPattern == '') {
                this.personalDetailsForm.addControl(element.FormControlName, new FormControl(''));
              } else {
                this.personalDetailsForm.addControl(element.FormControlName, new FormControl('', [Validators.pattern(element.FormPattern)]));
              }
            }
          }
  
        });
        this.mapdataaa(res.data);
      }else{
        this.finishedApi++
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }

      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
  }

  // async mapdataaa(e) {
  //   // this.personalDetailsFormArray = e.reduce(function (r, a) {
  //   //   r[a.FormControlName] = r[a.FormControlName] || [];
  //   //   r[a.FormControlName].push(a);
  //   //   return r;
  //   // }, Object.create(null));
  //   this.personalShow = true;
  //   this.spinner.hide()
  // }
  async mapdataaa(e) {
    try {
      this.personalDetailsFormArray = await e.reduce(async (rPromise, a) => {
        const r = await rPromise; 
        if (a.FormControlName) {
          r[a.FormControlName] = r[a.FormControlName] || [];
          r[a.FormControlName].push(a);
        }
        return r;
      }, Promise.resolve(Object.create(null))); 
      this.personalShow = true;
      this.finishedApi++
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    } catch (error) {
      console.error('Error processing data:', error);
      this.finishedApi++
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    }
  }
  
  ageCalculate() {
    if (((this.personalDetailsForm.controls['StuBirthDate'].value) <= this.minDate) ||
      ((this.personalDetailsForm.controls['StuBirthDate'].value) >= this.currentdate)) {
      this.personalDetailsForm.controls['StuAge'].setValue('');
    }
    else {
      let payload = this.personalDetailsForm.value;
      if (payload.StuBirthDate) {
        var timeDiff = Math.abs(
          Date.now() - new Date(payload.StuBirthDate).getTime()
        );
        let age = Math.floor(timeDiff / (1000 * 3600 * 24) / 365.25);
        this.personalDetailsForm.controls['StuAge'].setValue(age);
      }
    }
  }

  SubmitFormarkAsTouched() {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'PersonalDetails';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.spinner.hide();
      res.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            const control = this.personalDetailsForm.get(element.FormControlName);
            if (control) {
              control.markAsTouched();
              // return

            }
          }
        }
      });
      this.mapdataaa(res.data);

    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }


  submit() {
    if (this.personalDetailsForm.invalid) {


      this.SubmitFormarkAsTouched();
      return;
    } else {
      this.submitPersonalDetails();
    }
  }
  Update() {
    if (this.personalDetailsForm.invalid) {
      this.SubmitFormarkAsTouched();
      return;
    } else {
      this.updatePersonalDetails();
    }
  }

  submitPersonalDetails() {
    this.spinner.show();
    this.submitpayload = this.personalDetailsForm.value;
    let da = this.personalDetailsForm.value.StuBirthDate;
    this.submitpayload['StuBirthDate'] = this.datepipe.transform(da, 'yyyy-MM-dd');
    this.submitpayload['StuPassYr'] = parseInt(this.personalDetailsForm.value.StuPassYr);
    this.submitpayload['LoginId'] = parseInt(sessionStorage.getItem('StudentRGID'));
    this.umsService.addpersonalDetails(this.submitpayload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        // sessionStorage.setItem("StudentPersonalId", res.data);
        this.dialogRef.afterClosed().subscribe((result) => {
          // this.getScrutiny(sessionStorage.getItem("StudentPersonalId"));
        });
        this.next.emit();
      }
      else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }
  getTabName(e) {
    this.displayName = e;
    console.log("this.displayName",this.displayName);
    
  }
  // getTabDisplayName(): string {
  //   console.log('this.tabName',this.tabName)
  //   return `Current Tab: ${this.tabName}`;
  // }
  updatePersonalDetails() {
      this.UpdateScrutiny();
  }

  UpdateScrutiny() {
    this.spinner.show();
    this.submitpayload = this.personalDetailsForm.value;
    let da = this.personalDetailsForm.value.StuBirthDate;
    this.submitpayload['StuBirthDate'] = this.datepipe.transform(da, 'yyyy-MM-dd');
    this.submitpayload['StuPassYr'] = parseInt(this.personalDetailsForm.value.StuPassYr);
    this.submitpayload['StuId'] = this.StudentPersonalId;
    this.submitpayload['LoginId'] = parseInt(sessionStorage.getItem('StudentRGID'));
    this.umsService.updatePersonalDetails(this.submitpayload).subscribe((res) => {
      if (res.status) {
      this.umsService.setTabSaved('personalTab');
//       console.log('tabStatus', this.umsService.tabStatus);
// console.log('requiredTabs', this.tabs);
// console.log(
//   'isRequiredTabsSaved',
//   this.umsService.isRequiredTabsSaved(this.tabs)
// );

const canUpdateScrutiny =
  this.tabs &&
  this.umsService.isRequiredTabsSaved(this.tabs);
    this.spinner.hide();

    let data = {};
    data['message'] = res.message;
    data['title'] = 'Information';
    data['icon'] = 'fas fa-check';

    this.dialogRef =
      this.modalPopupService.openPopup<AlertboxComponent>(
        AlertboxComponent,
        data
      );

  if (canUpdateScrutiny) {
  const data = {};

  data['message'] =
    'Are You Sure You Have Updated ' +
    this.tabs +
    ' Tabs. Do You Want To Proceed?';

  data['title'] = 'Alert';
  data['icon'] = 'fa fa-question';

  this.dialogRef =
    this.modalPopupService.openPopup<ConformationModelComponent>(
      ConformationModelComponent,
      data
    );
  this.dialogRef.afterClosed().subscribe(result => {
    if (result === 'yes') {
      this.UpdScrtDetails();
        if (this.tabs?.includes('Wrong Payment')) {
      this.router.navigate(['/Fees']);
      }
    }
  });
}
        this.next.emit();
      }
      else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }


  UpdScrtDetails() { 
    this.spinner.show();
    let payload = {};
    payload['StuId'] = parseInt(this.StudentPersonalId)
    payload['SessionId'] = parseInt(sessionStorage.getItem('session'));
    payload['CgCode'] = this.College
    payload['CoCode'] = this.Course
    this.umsService.UpdScrtDetails(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.first.emit();
        location.reload();
      }
      else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }

  getApplyData() {
    this.calledApi++;
    let payload = {}
    payload['LoginId'] = sessionStorage.getItem('loginId');
    this.umsService.getApplyData(payload).subscribe((res) => {
      if (res.status) {
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
        this.Course = res.data[0]['Course'];
        this.College = res.data[0]['College']
        this.getCourseData(this.Course);
      }
      else {
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
    });
  }

  fetchMarritalStatus() {
    this.calledApi++;
    const payload = {};
    payload['CdType'] = 'MarSt';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
        this.marritalList = res.data;
        this.filteredmarritalstatusList = this.marritalList.slice();
      } else {
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++;
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
  }

  fetchBloodGroup() {
    this.calledApi++;
    const payload = {};
    payload['CdType'] = 'Bld';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
        this.bloodgroupList = res.data;
        this.filteredBloodGroupList = this.bloodgroupList.slice();
      } else {
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++;
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
  }

  fetchGender() {
    this.calledApi++;
    const payload = {};
    payload['CdType'] = 'SX';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
        this.genderList = res.data;
        this.filteredGenderList = this.genderList.slice();
      }
      else {
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++;
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
  }


  fetchMotherTounge() {
    this.calledApi++;
    const payload = {};
    payload['CdType'] = 'Lang';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
        this.mothertoungList = res.data;
        this.filteredMotherToungList = this.mothertoungList.slice();
      } else {
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++;
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
  }

  fetchAdmInfo() {
    this.calledApi++;
    const payload = {};
    payload['CdType'] = 'ADINF';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
        this.AdmInfoCodeList = res.data;
        this.filteredListAdmInfoCode = this.AdmInfoCodeList.slice();
      } else {
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++;
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    })
  }

  getCourseData(CoCode) {
    this.calledApi++;
    const payload = {};
    payload['CoCode'] = CoCode;
    this.umsService.getCourse(payload).subscribe(res => {
      if (res.status) {
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
        console.log("this is courseeeeeee data",res.data);
        
        this.RgNoPrFx =res.data[0]['CoRgPrfx'] 
        this.session
        console.log('this.session',this.session);
        
        // this.RollNoForPrfx = this.RgNoPrFx + element['SnYear'].slice(-2) + this.studentId
      }
      else {
        this.finishedApi++;
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++;
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    })
  }


    prepopulationContact() {
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    this.umsService.fetchContactDetails(payload).subscribe(res => {
      if (res.status) {
        if (res.data[0].StuNationality === 'OS') {
          this.umsService.studentProgressList['StudentReservation'] = 1;
        }
      } 
    }, (ERROR: HttpErrorResponse) => {
      
    })

  }
}
